import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const loadingSpinnerFn = /* @__PURE__ */ createRecipe('loadingSpinner', {
  "size": "s"
}, [])

const loadingSpinnerVariantMap = {
  "size": [
    "s"
  ]
}

const loadingSpinnerVariantKeys = Object.keys(loadingSpinnerVariantMap)

export const loadingSpinner = /* @__PURE__ */ Object.assign(memo(loadingSpinnerFn.recipeFn), {
  __recipe__: true,
  __name__: 'loadingSpinner',
  __getCompoundVariantCss__: loadingSpinnerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: loadingSpinnerVariantKeys,
  variantMap: loadingSpinnerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, loadingSpinnerVariantKeys)
  },
  getVariantProps: loadingSpinnerFn.getVariantProps,
})